import {NgModule} from '@angular/core';
import {NpsComponent} from './nps.component';
import {NpsOverallModule} from "../nps-overall/nps-overall.module";
import {NpsTrendModule} from "../nps-trend/nps-trend.module";
import {NpsCategoryModule} from "../nps-category/nps-category.module";
import {NpsCountModule} from "../nps-count/nps-count.module";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {AlertModule} from "ngx-bootstrap/alert";
import {NpsHelpModule} from "../nps-help/nps-help.module";


@NgModule({ declarations: [NpsComponent],
    exports: [NpsComponent], imports: [BrowserModule,
        FormsModule,
        NpsOverallModule,
        NpsTrendModule,
        NpsCategoryModule,
        NpsCountModule,
        AlertModule.forRoot(),
        NpsHelpModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class NpsModule {
}
